import { Box, Typography, TypographyProps } from "@mui/material";
import { FC, Fragment } from "react";
import { FontMap } from "../salify-next-layout/default/theme/font-family/font-family";

interface SalifyTypographyWrapperProps extends TypographyProps {
  components: Array<{ text: string; cssProps?: TypographyProps }>;
  cssProps?: TypographyProps;
}

const SalifyTypographyWrapper: FC<SalifyTypographyWrapperProps> = (props) => {
  if (!props.components || props.components.length === 0) return null;

  const validComponents = props.components.filter((item) => !!item.text);

  return (
    <Box {...props.cssProps} sx={{ display: "inline", ...props.cssProps?.sx }}>
      {validComponents.map((item, index) => (
        <Fragment key={index}>
          <Typography
            display="inline"
            {...props.cssProps}
            {...item.cssProps}
            fontFamily={
              typeof item.cssProps?.fontFamily === "string" &&
              FontMap[item.cssProps.fontFamily as keyof typeof FontMap]
                ? FontMap[item.cssProps!.fontFamily as keyof typeof FontMap]
                : typeof props.cssProps?.fontFamily === "string" &&
                    FontMap[props.cssProps.fontFamily as keyof typeof FontMap]
                  ? FontMap[props.cssProps!.fontFamily as keyof typeof FontMap]
                  : undefined
            }
          >
            {item.text}
          </Typography>
          {index < validComponents.length - 1 && <span>&nbsp;</span>}
        </Fragment>
      ))}
    </Box>
  );
};

SalifyTypographyWrapper.displayName = "SalifyTypographyWrapper";

export default SalifyTypographyWrapper;
